import { dataHooks } from '../../../../libs/dataHooks';

export const subHeaderBreadcrumbsDataHooks = dataHooks<{ categoryLink: {} }>('breadcrumbs');
